/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const OrderManagement = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73116 3.84037H2.53994C1.82837 3.84037 1.24191 4.24221 1.2077 4.75454L0.00154881 22.9943C-0.0160449 23.2561 0.116886 23.513 0.368085 23.703C0.620262 23.893 0.968228 24 1.33379 24H22.6662C23.0308 24 23.3797 23.893 23.6319 23.703C23.8831 23.513 24.016 23.2568 23.9984 22.9943L22.7913 4.75454C22.7581 4.24221 22.1716 3.84037 21.4601 3.84037H17.3979C17.3979 1.71926 15.011 0 12.065 0C9.11902 0 6.73116 1.71926 6.73116 3.84037ZM12.0641 0.960938C14.2721 0.962345 16.0608 2.25091 16.0628 3.84068H8.0625C8.06641 2.25091 9.85609 0.962345 12.0641 0.960938ZM17.3939 8.16119V4.80078H21.4405L22.4052 19.2009H1.58398L2.536 4.80078H6.72723V8.16119C6.72723 8.4258 7.02534 8.64115 7.39383 8.64115C7.76232 8.64115 8.05946 8.4258 8.05946 8.16119V4.80078H16.0597V8.16119C16.0597 8.4258 16.3588 8.64115 16.7273 8.64115C17.0958 8.64115 17.3939 8.4258 17.3939 8.16119ZM1.52263 20.1602H22.4709L22.6645 23.0399H1.33203L1.52263 20.1602Z"
        fill="black"
      />
    </BaseSvgIcon>
  )
}

export default OrderManagement
